module.exports = __webpack_public_path__ + "static/media/Apple-icon.4e29416d.png";